import {classNames} from "shared/lib/classNames/classNames";
//import Logo from "shared/assets/icons/AvalornFooterLogo.svg";
import cls from "./Footer.module.scss";
import {useState} from "react";
import Socials from "shared/ui/Socials/Socials";
import Modal from "shared/ui/Modal/Modal";
import {Cookie} from "widgets/Cookie";
import Logo from "shared/assets/icons/CuttedDecoration.svg";
import {AppLink} from "../../../shared/ui/AppLink/AppLink";

interface FooterProps {
    className?: string
}

export const Footer = ({ className }: FooterProps) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className={classNames(cls.Footer, {}, [className])}>
            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
                <Cookie onAccept={() => setIsOpen(false)} onDecline={() => setIsOpen(false)}/>
            </Modal>
            <div className={classNames("container container__main")}>
                <div className={cls.Footer__social}>
                    <div className={cls.Privacy}>
                        {`HYPERAD LAB LTD\n41 DEVONSHIRE STREET, GROUND FLOOR, LONDON W1G 7AJ\n\nReg No: 16391721`}
                    </div>

                    <Socials className={cls.Footer__socials}/>
                </div>
            </div>

            <div className={cls.Footer__divider}/>

            <div className={classNames("container container__main")}>
                <div className={cls.Footer__rights}>
                    <span
                        className={classNames(cls.Privacy__link, {}, [cls.Privacy__link_cookie])}
                        onClick={() => setIsOpen(true)}
                    >
                        Cookie Policy
                    </span>
                    <AppLink
                        href={"/terms"}
                        className={classNames(cls.Privacy__link, {}, [cls.Privacy__link_cookie])}
                    >
                        Terms
                    </AppLink>
                    <AppLink
                        href={"/policy"}
                        className={classNames(cls.Privacy__link, {}, [cls.Privacy__link_cookie])}
                    >
                        Policy privacy
                    </AppLink>
                    <div className={cls.rights__text}>
                        © 2025 Hyperad Lab.All rights reserved.
                    </div>
                </div>
            </div>
        </div>
    )
};
